import React from "react";


export default class MapList extends React.Component {
	state = {
		places: {}
	}
	onComponentMount = this.onComponentMount.bind(this)

	onComponentMount(node) {
		if (!this.state.sMap && node) {
			//this.initiateMap(node);
		}
	}
	

	initiateMap(node) {

		let places = this.props.places;
		if (!places)
			return null;
		var m = new SMap(node);
		var points = [];
		var markers = [];
		places.forEach((place) => {
			var cord = SMap.Coords.fromWGS84(place.store.gpsLat, place.store.gpsLon);
			points.push(cord);
			markers.push({
				coords: cord,
				id: place.store.id,
				title: place.store.title,
			});
		});
		var compCenter = m.computeCenterZoom(points);
		var zoom = compCenter[1];
		if (zoom > 10) zoom = this.props.defaultZoom;
		m.setCenterZoom(compCenter[0], zoom);
		m.addDefaultLayer(SMap.DEF_BASE).enable();
		if (this.props.controlsEnabled) {
			m.addDefaultControls();
		}
		var layer = new SMap.Layer.Marker();
		m.addLayer(layer);
		layer.enable();
		markers.forEach((marker) => {
			layer.addMarker(
				new SMap.Marker(
					marker.coords,
					marker.id,
					{
						url: 'Content/view/images/map-1.png',
						title: marker.title
					}));
		});
		window.onresize = function () {
			var compCenter = m.computeCenterZoom(points);
			var zoom = compCenter[1];
			if (zoom > 10) zoom = 10;
			m.setCenterZoom(compCenter[0], zoom);
		};
	}

	render = () => {
		if (!this.props.places)
			return null;
		return (<div className="map-list" style={{ background: 'none' }} >
			<div id="mapproduct" style={{ width: '100%', height: '100%',position:'absolute',left:'0px',top:'0px'}} ref={(rf) => this.onComponentMount(rf)} />
		</div>);
	}
}




